import { api } from '@/api/client'

export interface ChatPerson {
  user_id: number
  name: string
  email: string
  avatar_url?: string | null
  is_bot?: boolean
}

export interface ChatOrgMember extends ChatPerson {
  role: string
  is_owner: boolean
}

export interface ChatOrg {
  id: number
  name: string
  slug: string
  member_count: number
  members: ChatOrgMember[]
}

export interface HumanConversation {
  id: number
  conv_type: 'dm' | 'org' | 'chamado'
  is_robo_dm?: boolean
  title: string
  last_message_at: string | null
  unread: number
  /** Foto do outro participante (DM) ou logo do grupo/org. Resolvido no backend. */
  avatar_url?: string | null
}

export const chatDirectoryApi = {
  people: () =>
    api
      .get<{ items: ChatPerson[] }>('/v1/chat/directory/people')
      .then((r) => r.data.items),

  organizations: () =>
    api
      .get<{ items: ChatOrg[] }>('/v1/chat/directory/organizations')
      .then((r) => r.data.items),

  humanConversations: () =>
    api
      .get<{ items: HumanConversation[] }>('/v1/conversations', {
        params: { type: 'human' },
      })
      .then((r) => r.data.items),

  openDm: (userId: number) =>
    api
      .post<{ conversation_id: number }>('/v1/chat/dm', { user_id: userId })
      .then((r) => r.data.conversation_id),

  openOrg: (orgId: number) =>
    api
      .post<{ conversation_id: number }>(`/v1/chat/org/${orgId}/open`)
      .then((r) => r.data.conversation_id),

  toggleMute: (cid: number, muted: boolean, duration?: MuteDuration) =>
    api
      .put(`/v1/chat/conversations/${cid}/mute`, { muted, duration })
      .then((r) => r.data),
}

/** Durações de silêncio estilo WhatsApp. 'forever' e ausência = sem expiração. */
export type MuteDuration = '8h' | '24h' | '7d' | 'forever'
